import axios from 'axios';
const apiClient = axios.create({
  // http://localhost:3000/
  baseURL: 'https://api.toolbox.otca.org',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  getTools(params) {
    return apiClient.get('/ferramentas', { params });
  },
  getToolById(id) {
    return apiClient.get(`/ferramentas/${id}`);
  },
  getVersions(params) {
    return apiClient.get('/versoes', { params });
  },
  searchTools(params) {
    return apiClient.get('/ferramentas', { params });
  },
  getConteudoVersoesPorFerramenta(id, idioma) {
    return apiClient.get(`/ferramentas/${id}/versoes/conteudo`, {
      params: { idioma }
    });
  },

  // Admin
  login(email, senha) {
    return apiClient.post('/auth/login', { email, senha });
  },
  updateVersao(id, data) {
    const token = sessionStorage.getItem('admin_token');
    return apiClient.put(`/versoes/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  getHistoricoVersao(versaoId) {
    const token = sessionStorage.getItem('admin_token');
    return apiClient.get(`/versoes/${versaoId}/historico`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  restaurarVersao(versaoId, historicoId) {
    const token = sessionStorage.getItem('admin_token');
    return apiClient.post(`/versoes/${versaoId}/restaurar/${historicoId}`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  createFerramenta(data) {
    const token = sessionStorage.getItem('admin_token');
    return apiClient.post('/ferramentas', data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  updateFerramenta(id, data) {
    const token = sessionStorage.getItem('admin_token');
    return apiClient.put(`/ferramentas/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  deleteFerramenta(id) {
    const token = sessionStorage.getItem('admin_token');
    return apiClient.delete(`/ferramentas/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  uploadImagem(file) {
    const token = sessionStorage.getItem('admin_token');
    const formData = new FormData();
    formData.append('imagem', file);
    return apiClient.post('/upload/imagem', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  },
};
